export default __webpack_public_path__ + "static/media/second_icon.d239aff1.svg";